import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {
    SimplePresentation,
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../SimplePresentationRunner";
import {LocalPresentation} from "./runnerpresentations/LocalPresentation";
import {XwaysHoarder2} from "../XwaysHoarder2";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {NormalWin} from "./runnerpresentations/NormalWin";
import {XSplitPresentation} from "./runnerpresentations/XSplitPresentation";
import {XWayPresentation} from "./runnerpresentations/XWayPresentation";
import {FreespinEnd} from "./runnerpresentations/freespin/FreespinEnd";
import {MaxWinPresentation} from "./runnerpresentations/maxwin/MaxWinPresentation";
import {InitialWin} from "./runnerpresentations/InitialWin";
import {BigWin} from "./runnerpresentations/BigWin";
import {ScatterWinPresentation} from "./ScatterWinPresentation";
import {StickyUnlockPresentation} from "./runnerpresentations/shared/StickyUnlockPresentation";
import {XSplitNudgePresentation} from "./runnerpresentations/XSplitNudgePresentation";
import {XWaysMergePresentation} from "./runnerpresentations/XWaysMergePresentation";
import {SCCToXSplitConversionPresentation} from "./runnerpresentations/SSCToXSplitConversionPresentation";
import {
    ReverseXWaysAndWildToSplitConversionPresentation
} from "./runnerpresentations/ReverseXWaysAndWildToSplitConversionPresentation";
import {StickyLockPresentation} from "./runnerpresentations/StickyLockPresentation";
import {XWaysSizeRevealPresentation} from "./runnerpresentations/XWaysSizeRevealPresentation";
import {LootRespinBeforeStart} from "./runnerpresentations/lootrespin/LootRespinBeforeStart";
import {LootRespinEnd} from "./runnerpresentations/lootrespin/LootRespinEnd";
import {PlusFsPresentation} from "./runnerpresentations/shared/PlusFsPresentation";
import {LevelUpgradePresentation} from "./runnerpresentations/LevelUpgradePresentation";


export class NormalWinPresentation implements FlowStatePresentation {
    name = "NormalWinPresentation";
    private _presentations: SimplePresentation[];

    constructor() {
        this._presentations = [
            new PlusFsPresentation(),
            new LootRespinEnd(),
            new StickyUnlockPresentation(),//remove tape from all sticky XW and XS
            new XWaysMergePresentation(),//merge XWays
            new XWaysSizeRevealPresentation(),//reveal XWaysSize
            new XSplitNudgePresentation(),// do nudge part for XN,also in respin XN convert to XS
            new XSplitPresentation(),//work all XS and XN left to right and turn to wild
            new XWayPresentation(),//Xways reel scaling and paying symbol reveal
            new LocalPresentation((controller: SimplePresentationRunnerController) => this.noWin(controller), () => {
                return XwaysHoarder2.model.winRatio <= 0;
            }),
            new InitialWin(),
            new NormalWin(),
            new BigWin(),
            new ReverseXWaysAndWildToSplitConversionPresentation(),//reverse Xways scaling and wild to xs conversion
            new ScatterWinPresentation(),//sc and ssc  win
            new SCCToXSplitConversionPresentation,//transform possible positions of SSC to XS before bonus and in bonus as well
            new LootRespinBeforeStart(),//locks LT symbol post reveal anim
            new StickyLockPresentation(),//sticky lock XW and XS and add tape,also for SC/SSC in respin
            new LevelUpgradePresentation(),//includes light progression,lock of xw and xs , symbol remove and +1 anims in bonus
            new FreespinEnd(),
            new MaxWinPresentation(),
        ]
    }

    public start(flowStateController: FlowStateController) {
        SimplePresentationRunner.run(this._presentations, () => flowStateController.finish(), (callback?: Function) => flowStateController.setSkipCallback(callback), "XwaysHoarder2WinRunner ");
    }

    private noWin(controller: SimplePresentationRunnerController) {
        const useTotalWin = XwaysHoarder2.model.gameData.accumulatedRoundWin != XwaysHoarder2.model.gameData.totalSpinWinnings || XwaysHoarder2.model.data.mode != GameMode.NORMAL;
        XwaysHoarder2.keypadPlugin.setWin(XwaysHoarder2.model.gameData.accumulatedRoundWin, useTotalWin, XwaysHoarder2.isWinBelowStake());
        controller.setSkipCallback();
        controller.finish();
    }
}